// removed by extract-text-webpack-plugin
module.exports = {"base":"src-components----Icon-module---base---2YiMF","twitter":"src-components----Icon-module---twitter---1VC5t","github":"src-components----Icon-module---github---2Z6wM","instagram":"src-components----Icon-module---instagram---2Bqlu","dribbble":"src-components----Icon-module---dribbble---1XYt3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Icon.module.css
// module id = 125
// module chunks = 35783957827783 43201937662106